import { reactive, computed } from 'vue';

export interface AuthProvider {
  provider: string;
  url: string;
}

interface AuthProvidersState {
  email: string | null;
  authProviders: AuthProvider[];
}

const state = reactive<AuthProvidersState>({
  email: null,
  authProviders: [],
});

export function useAuthProvidersStore() {
  const email = computed(() => state.email);
  const authProviders = computed(() => state.authProviders);
  const hasProviders = computed(() => state.authProviders.length > 0);
  const hasAuth0VtsDurstAdapter = computed(() => state.authProviders.some(p => p.provider === 'auth0_vts_durst'));
  const auth0VtsDurstAdapterUrl = computed(() => {
    const provider = state.authProviders.find(p => p.provider === 'auth0_vts_durst');
    return provider?.url ?? null;
  });

  function setEmail(value: string) {
    state.email = value;
  }

  function setAuthProviders(providers: AuthProvider[]) {
    state.authProviders = providers;
  }

  function reset() {
    state.email = null;
    state.authProviders = [];
  }

  return {
    email,
    authProviders,
    hasProviders,
    hasAuth0VtsDurstAdapter,
    auth0VtsDurstAdapterUrl,
    setEmail,
    setAuthProviders,
    reset,
  };
}
